import * as React from 'react';

import { cn, PhotoCard } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { PhotoRequirementSelect } from './PhotoRequirementSelect';

import { $photoRequirements } from '~/modules/trade/_state/loadTabPhotos.state';
import { GenericFile } from '~/modules/trade/types/file';
import { getFileDisplayState } from '~/modules/trade/utils/fileUpload';

type RequiredPhotoCardProps = {
  file: GenericFile;
  onView?: () => void;
  onDownload: () => void;
  onDelete: () => void;
  onRequirementChange: (requirementId?: string) => void;
  onRetry?: () => void;
  onDismissError?: () => void;
  isDownloading: boolean;
};

export const RequiredPhotoCard: React.FC<RequiredPhotoCardProps> = ({
  file,
  onView,
  onDownload,
  onDelete,
  onRequirementChange,
  onRetry,
  onDismissError,
  isDownloading,
}) => {
  const photoRequirements = useAtomValue($photoRequirements);
  const { hasError, isPending, isUploading, displayImageUrl } =
    getFileDisplayState(file);

  return (
    <div className={cn('@RequiredPhotoCard flex flex-col')}>
      <PhotoCard
        imageUrl={displayImageUrl}
        fileName={file.fileName}
        timeStamp={file.updatedAt ?? file.createdAt}
        hasError={hasError}
        isUploading={isUploading || isPending}
        onView={onView}
        onDownload={onDownload}
        onDelete={onDelete}
        onRetry={onRetry}
        onDismissError={onDismissError}
        isDownloading={isDownloading}
      />

      <div className="mt-2">
        <PhotoRequirementSelect
          value={file.metadata?.photoRequirementId ?? undefined}
          options={photoRequirements}
          onChange={onRequirementChange}
          disabled={isUploading || isPending || hasError}
        />
      </div>
    </div>
  );
};
